import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class Modal {
  constructor(lenis) {
    this.lenis = lenis;

    this.activeClass = 'is-active';
    this.currentY = 0;
    this.bodyTag = document.querySelector('body');

    this.pageElem = document.querySelector("#js-main");
    if(this.pageElem) {
      this.page = this.pageElem.dataset.page;
    }
    
    this.modalTrigger = [...document.querySelectorAll('.js-modal_trigger')];
    this.modalTarget = [...document.querySelectorAll('.js-modal_target')];
    this.closeModal = [...document.querySelectorAll('.js-modal_close')];
    this.modalBg = document.querySelector('.js-modal_bg');

    if(this.modalTrigger.length !== 0) {
      this.init();
    }
  }

  init() {
    this.modalOpen();
    this.modalClose();
    if(this.page === 'museum_trivia'){
      this.modalNav();
    };
  }

  modalOpen() {
    this.modalTrigger.forEach(el => {
      el.addEventListener('click', async () => {
        el.setAttribute('aria-expanded', 'true');

        const targetId = el.getAttribute('aria-controls');

        // すでに表示用モーダルがあるか確認
        let target = document.querySelector(`.js-modal_target[id="${targetId}"]`);

        //templateタグ使用の場合
        if (!target){
          const tpl = document.querySelector(`template[data-template="${targetId}"]`);
          if (tpl && tpl.content) {
            // template内の画像srcを収集
            const imgTags = tpl.content.querySelectorAll('img');
            const preloadPromises = [...imgTags].map(img => {
              return new Promise((resolve) => {
                const preload = new Image();
                preload.src = img.getAttribute('src');
                preload.onload = resolve;
                preload.onerror = resolve; // エラーでも resolve して進行させる
              });
            });

            await Promise.all(preloadPromises);
            
            const clone = tpl.content.cloneNode(true);
            document.body.appendChild(clone);

            // 追加後に再取得
            target = document.querySelector(`.js-modal_target[id="${targetId}"]`);
            if (target) this.bindCloseEvents(target);
          }
        }  
        
        if (target && this.modalBg) {
          target.classList.add(this.activeClass);
          this.modalBg.classList.add(this.activeClass);
          target.setAttribute('aria-hidden', 'false');
          this.bodyFixed();
        }
      });
    });
  }

  modalClose() {
    this.closeModal.forEach(el => {
      el.addEventListener('click', (e) => {
        e.currentTarget.blur();
        this.modalCloseCnt();
      });
    });

    this.modalTarget.forEach(modal => {
      modal.addEventListener('click', (e) => {
        const isClickInside = e.target.closest('.o-modal__box_inner');
        if (!isClickInside) {
          this.modalCloseCnt();
        }
      });
    });
  }


  modalCloseCnt(target = null) {
    const trigger = document.querySelector('.js-modal_trigger[aria-expanded="true"]');

    // 明示されていない場合はアクティブなものを取得（後方互換）
    if (!target) {
      target = document.querySelector('.js-modal_target[aria-hidden="false"]');
    }

    if (!target) return;

    // 閉じるボタンへのフォーカスを確実に外す
    if (target.contains(document.activeElement)) {
      document.activeElement.blur();
    }

    requestAnimationFrame(() => {
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      target.setAttribute('aria-hidden', 'true');
      target.classList.remove(this.activeClass);
      if (this.modalBg) this.modalBg.classList.remove(this.activeClass);

      this.bodyStatic();
    });
  };

  bindCloseEvents(modal) {
    const closeBtns = modal.querySelectorAll('.js-modal_close');
    closeBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.currentTarget.blur();
        this.modalCloseCnt(modal);  // ★ 現在のモーダルを指定
      });
    });

    modal.addEventListener('click', (e) => {
      const isClickInside = e.target.closest('.o-modal__box_inner');
      if (!isClickInside) {
        this.modalCloseCnt(modal); // ★ 外側クリック → このモーダルだけ閉じる
      }
    });
  }



  bodyFixed() {
    this.currentY = this.lenis?.actualScroll || window.scrollY;
    this.bodyTag.classList.add('is-modal-open');

    //GSAP の ScrollTrigger が使われている場合、スクロール連動アニメーションを一時停止。
    if (window.ScrollTrigger) {
      window.ScrollTrigger.getAll().forEach(t => t.disable(false));
    }

    let startY = 0;

    // タッチ開始時の Y 座標 を記録
    this._onTouchStart = (e) => {
      const modalBox = e.target.closest('.o-modal__box_inner');
      if (modalBox) {
        startY = e.touches[0].clientY;
      }
    };

    //スクロール処理　モバイル対応
    this._onTouchMove = (e) => {
      const modalBox = e.target.closest('.o-modal__box_inner');

      if (modalBox) {
        const scrollTop = modalBox.scrollTop;
        const scrollHeight = modalBox.scrollHeight;
        const clientHeight = modalBox.clientHeight;

        const currentY = e.touches[0].clientY;
        const deltaY = startY - currentY;
        const isScrollingDown = deltaY > 0;

        // ★ スクロールできる要素かどうかを判定
        const isScrollable = scrollHeight > clientHeight;

        if (
          isScrollable &&
          (
            (isScrollingDown && scrollTop + clientHeight >= scrollHeight) ||
            (!isScrollingDown && scrollTop <= 0)
          )
        ) {
          e.preventDefault(); // スクロール限界時のみ防止
        }

        // ★ スクロールできない（高さ不足）場合は全体を止める
        if (!isScrollable) {
          e.preventDefault();
        }
      } else {
        e.preventDefault(); // モーダル外 → 背景スクロール防止
      }
    };


    // スクロール処理　PC対応
    this._onWheel = (e) => {
      const modalBox = e.target.closest('.o-modal__box_inner');
      if (!modalBox) {
        e.preventDefault();
        return;
      }

      const scrollTop = modalBox.scrollTop;
      const scrollHeight = modalBox.scrollHeight;
      const clientHeight = modalBox.clientHeight;
      const isScrollable = scrollHeight > clientHeight;

      if (!isScrollable) {
        e.preventDefault();
        return;
      }

      const deltaY = e.deltaY || -e.wheelDelta || e.detail;
      const isScrollingDown = deltaY > 0;

      const atBottom = scrollTop + clientHeight >= scrollHeight;
      const atTop = scrollTop <= 0;

      if ((isScrollingDown && atBottom) || (!isScrollingDown && atTop)) {
        e.preventDefault();
      }
    };

    // イベント登録
    window.addEventListener('wheel', this._onWheel, { passive: false });
    window.addEventListener('touchstart', this._onTouchStart, { passive: false });
    window.addEventListener('touchmove', this._onTouchMove, { passive: false });
  };




  bodyStatic() {
    //背景スクロール防止のイベント を解除
    window.removeEventListener('wheel', this._onWheel);
    window.removeEventListener('touchstart', this._onTouchStart);
    window.removeEventListener('touchmove', this._onTouchMove);

    this.bodyTag.classList.remove('is-modal-open');

    //Lenis スクロール位置の復元
    if (this.lenis) {
      this.lenis.scrollTo?.(this.currentY, { immediate: true });
      this.lenis.resize?.();
    }

    //GSAP ScrollTrigger の再有効化  非同期に呼び出すためsetTimeout
    setTimeout(() => {
      if (window.ScrollTrigger) {
        window.ScrollTrigger.getAll().forEach(t => t.enable(false));
        ScrollTrigger.refresh();
      }
    }, 0);
  }



  modalNav() {
    // 背景ではないモーダルだけを取得
    const allModals = [...document.querySelectorAll('.js-modal_target:not(.js-modal_bg)')];
    const total = allModals.length;

    this.modalTarget.forEach((modal, index) => {
      if (modal.classList.contains('js-modal_bg')) return; // 背景ならスキップ

      const prevBtn = modal.querySelector('.js-modalLink--prev');
      const nextBtn = modal.querySelector('.js-modalLink--next');

      const modalIndex = allModals.indexOf(modal);
      const prevIndex = (modalIndex - 1 + total) % total;
      const nextIndex = (modalIndex + 1) % total;

      const prevModal = allModals[prevIndex];
      const nextModal = allModals[nextIndex];

      if (prevModal && prevBtn) {
        const title = prevModal.querySelector('.js-museumModal-title')?.innerHTML.trim();
        if (title) prevBtn.querySelector('p').innerHTML = title;
        prevBtn.addEventListener('click', () => {
          this.switchModal(modal, prevModal);
        });
      }

      if (nextModal && nextBtn) {
        const title = nextModal.querySelector('.js-museumModal-title')?.innerHTML.trim();
        if (title) nextBtn.querySelector('p').innerHTML = title;
        nextBtn.addEventListener('click', () => {
          this.switchModal(modal, nextModal);
        });
      }
    });
  }

 

  // モーダル切り替え処理
  switchModal(currentModal, targetModal) {
    document.activeElement.blur();

    requestAnimationFrame(() => {
      currentModal.setAttribute('aria-hidden', 'true');
      currentModal.classList.remove(this.activeClass);

      targetModal.setAttribute('aria-hidden', 'false');
      targetModal.classList.add(this.activeClass);

    });
  }

}